import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default (options) => {
  const {
    title, headers, rows, widths, fileName, fontSize = 9,
  } = options;

  const docDefinition = {
    pageOrientation: 'landscape',
    content: [
      { text: title, style: 'header' },
      '',
      {
        table: {
          widths,
          body: [
            headers,
            ...rows,
          ],
        },
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
    },
    defaultStyle: {
      fontSize,
    },
  };


  pdfMake.createPdf(docDefinition).download(`${fileName}_${new Date().getTime()}`);
};
